module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2021_17.b5c6ce92.jpg";